// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__18YNZ","header":"Messages_header__1WAPr"};